import React from 'react';
import PropTypes from 'prop-types';
import { formatCurrency, formatWholeDollars } from '../../helpers/convertToCurrency';

/**
 * How much of the approval amount a shopper has committed, and how much is left.
 * Used on the in-store cart screens, where the cart total moves as items are added.
 */
const toCents = amount => Math.round((Number(amount) || 0) * 100);

export default function AvailableLimitMeter({ limit, used }) {
  const limitValue = Number(limit) || 0;
  const usedValue = Number(used) || 0;
  // Subtract in whole cents: $2,400.00 - $2,189.98 is exactly $210.02.
  const available = Math.max(toCents(limitValue) - toCents(usedValue), 0) / 100;
  const percentUsed = limitValue > 0 ? Math.min(Math.max((usedValue / limitValue) * 100, 0), 100) : 0;

  return (
    <section className="k-limit-meter">
      <div className="k-limit-meter__row">
        {/* The headline reads as whole dollars, while both amounts are exact. */}
        <span className="k-limit-meter__label">Used of your {formatWholeDollars(limitValue)}</span>
        <span className="k-limit-meter__amount">{formatCurrency(usedValue)}</span>
      </div>
      <progress
        className="k-limit-meter__track"
        aria-label="Amount of your approval used"
        max={100}
        value={percentUsed}
      />
      <div className="k-limit-meter__row k-limit-meter__row--available">
        <span className="k-limit-meter__label">Still available</span>
        <span className="k-limit-meter__amount">{formatCurrency(available)}</span>
      </div>
    </section>
  );
}

AvailableLimitMeter.propTypes = {
  limit: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  used: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
};

AvailableLimitMeter.defaultProps = {
  limit: 0,
  used: 0,
};
